// extracted by mini-css-extract-plugin
module.exports = {"dialogPaper":"styles_dialogPaper__2yHsK","yayImg":"styles_yayImg__33WT7","submittedHeader":"styles_submittedHeader__gQNAP","doneButton":"styles_doneButton__1yQeo"};